<template>
	<div class="work-group-view p-10">
		<div class="p-10 bg-white tcenter">
			<b>{{d.name}}</b>
		</div>
		<img @click="go_nav" class="map" :src="`https://api.map.baidu.com/staticimage/v2?ak=iPzFbqGXnGBhWpxG93ED9q8qgPZltNGO&center=${d.lng},${d.lat}&width=600&height=300&zoom=18&markers=${d.lng},${d.lat}`" />
		<div class="bg-white p-10 f-color2">
			<van-icon name="location" />
			{{d.address}}
		</div>
		<div class="bg-white p-10 mt-5">
			<div class="subject van-hairline--bottom pb-10 fz14">
				人员列表
			</div>
			<div class="d-flex member-item van-hairline--bottom" v-for='(item) in d.members' :key='item.id'>
				<van-image :src='item.avatar' round></van-image>
				<div class="flex-1 ml-10">
					<div><b>{{item.roleName}}</b></div>
					<div class="fz14 f-color3">{{item.name}}</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import { mapModules, mapRules } from "vuet";
	export default {
		mixins: [
			mapModules({
				data: "root/workgroup/view",
			}),
			mapRules({
				router: "root/workgroup/view",
			}),
		],
		data() {
			return {};
		},
		computed: {
			d() {
				return this.data.detail;
			},
		},
		methods: {
			go_nav() {
				window.location.href = `http://api.map.baidu.com/marker?location=${this.d.lng},${this.d.lat}&title=SRCD工业园&content=智能物联场景中心&output=html&src=webapp.baidu.openAPIdemo`;
			},
		},
	};
</script>
<style lang="less">
.work-group-view {
	.map {
		width: 100%;
		vertical-align: middle;
	}

	.subject {
		&::before {
			content: " ";
			display: inline-block;
			width: 5px;
			height: 16px;
			background-color: @main;
			transform: translateY(3px);
		}
	}

	.van-image {
		width: 45px;
		height: 45px;
		border: 1px solid #eeeeee;
		padding: 2px;
	}

	.member-item {
		padding: 5px;
	}
}
</style>